import React from 'react'
import { Link, useLocation } from 'react-router-dom';

export default function OrderBreadCrumbs({ xStatus }) {
    const location = useLocation();
    const vPathName = location.pathname;
    return (
        <div className="container-fluid p-0 mt-0 mb-4 breadcrumb">
            {vPathName === '/PendingOrder' ? (
                <div>
                    <span className="breadcrumb-arrow-inactive ">Pending Orders</span>
                </div>
            ) : vPathName === '/PostedOrder' ? (
                <div>
                    <span className="breadcrumb-arrow-inactive ">Completed Orders</span>
                </div>
            ) : vPathName === '/OrderDetail' ? (
                <div className="d-flex">
                    <Link
                        to={xStatus == 'ENTER' ? "/PendingOrder" : "/PostedOrder"}
                        state={location}
                        className={'breadcrumb-arrow-active mr-2'}>
                        {xStatus == 'ENTER' ? "Pending Orders" : "Completed Orders"}
                    </Link>
                    <div>
                        <span className="breadcrumb-arrow-inactive">Order Detail </span>
                    </div>
                </div>
            ) : (
                <></>

            )}
        </div>
    );
}
